import get from 'lodash/get';
import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { NEWS_BASE_URL } from 'services/news/configs';
import { fetcher } from 'services/utils';
import useSWR, { useSWRConfig } from 'swr';

const getNewsDetailEndpoint = `${NEWS_BASE_URL}/get-news`;

export const useMutateCaseNewsDetail = () => {
  const { mutate } = useSWRConfig();
  const { newsId } = useParams();

  return useCallback(() => {
    mutate(`${getNewsDetailEndpoint}/${newsId}`);
  }, [mutate, getNewsDetailEndpoint]);
};

const useGetNewsDetail = () => {
  const { newsId } = useParams();
  const { data, isValidating, error, mutate } = useSWR(`${getNewsDetailEndpoint}/${newsId}`, fetcher);

  return {
    data: get(data, 'data', null),
    isLoading: isValidating,
    mutate,
    errorMessage: error
  };
};

export default useGetNewsDetail;
